import {call, put, takeLatest} from "redux-saga/effects";
import * as types from "../actions/actionTypes";
import {EventAction} from "../actions";
import * as EventApi from "../api/event";
import {toastr} from "react-redux-toastr";
import checkErrorMessagesExist from "../assets/checkErrorMessagesExist";

export function* watcherEvent() {
  yield takeLatest(types.EVENT_LIST_REQUEST, worker);
}

function* worker(action) {
  try {
    const response = yield call(fetchList, action.date);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    let data = response.data;
    yield put(EventAction.getSuccess(data));
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    yield put(EventAction.getFailure(error.response.data));
  }
}

function fetchList(date) {
  return EventApi.getList(date);
}
